const labelAliases = {
  "andaman and nicobar islands": "andaman and nicobar",
  "andaman nicobar": "andaman and nicobar",
  "dadra and nagar haveli": "dadra and nagar haveli and daman and diu",
  "daman and diu": "dadra and nagar haveli and daman and diu",
  "dadra and nagar haveli and daman and diu": "dadra and nagar haveli and daman and diu",
  "leh and ladakh": "ladakh",
  "nct of delhi": "delhi",
  orissa: "odisha",
  uttaranchal: "uttarakhand",
};

const palette = ["#FFF7ED", "#FED7AA", "#FDBA74", "#FB923C", "#EA580C", "#7C2D12"];

export const normalizeMapJoinKey = (value) => {
  const text = String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/\([^)]*\)/g, " ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return labelAliases[text] || text;
};

export const slugifyMapLabel = (value) =>
  String(value || "region")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "region";

export const getMapMetricValue = (item, metricMode) => {
  if (!item) return 0;
  return metricMode === "projects" ? Number(item.project_count || 0) : Number(item.total_spend_crore || 0);
};

export const buildMetricStops = (values) => {
  const validValues = values.filter((value) => Number.isFinite(value) && value > 0).sort((left, right) => left - right);
  if (validValues.length === 0) {
    return { minLog: 0, maxLog: 0, thresholds: [0.12, 0.28, 0.46, 0.68, 0.84] };
  }

  const logValues = validValues.map((value) => Math.log10(value + 1));
  return {
    minLog: logValues[0],
    maxLog: logValues[logValues.length - 1],
    thresholds: [0.12, 0.28, 0.46, 0.68, 0.84],
  };
};

export const getMapFillColor = (value, stops) => {
  if (!value) return "#E5E7EB";
  const rawLogValue = Math.log10(Number(value || 0) + 1);
  const normalizedRange = Math.max((stops?.maxLog || 0) - (stops?.minLog || 0), 1e-6);
  const normalized = Math.min(Math.max((rawLogValue - (stops?.minLog || 0)) / normalizedRange, 0), 1);
  const contrastAdjusted = Math.min(Math.pow(normalized, 0.82), 1);
  if (contrastAdjusted <= stops.thresholds[0]) return palette[0];
  if (contrastAdjusted <= stops.thresholds[1]) return palette[1];
  if (contrastAdjusted <= stops.thresholds[2]) return palette[2];
  if (contrastAdjusted <= stops.thresholds[3]) return palette[3];
  if (contrastAdjusted <= stops.thresholds[4]) return palette[4];
  return palette[5];
};

export const formatMapMetric = (value, metricMode) => {
  const numericValue = Number(value || 0);
  if (metricMode === "projects") {
    return `${numericValue.toLocaleString("en-IN")} projects`;
  }
  return `₹${numericValue.toLocaleString("en-IN", { maximumFractionDigits: 2 })} Cr`;
};

export const formatCompactMapMetric = (value, metricMode) => {
  const numericValue = Number(value || 0);
  if (metricMode === "projects") {
    return numericValue.toLocaleString("en-IN");
  }
  return `₹${numericValue.toLocaleString("en-IN", { maximumFractionDigits: 1 })} Cr`;
};